import home from './home'
import components from './components'
import addProduct from './add-product'
import saleOrder from './sale-order'
import productList from './product-list'
import productListGift from './product-list-gift'
import productSku from './product-sku'
import catset from './catset'
import goodsImport from './goods-import'
import productReviews from './product-reviews'
import reviewList from './review-list'
import extendedPrice from './extended-price'
import _idorder from './_idorder'
import shippackage from './shippackage'
import shippackagedetail from './shippackagedetail' // shippackage里的组件   存在组件details/ecourier
import ecourier from './ecourier'
import _id from './_id'
import storelist from './storelist'
import storeSetting from './store-setting'
import accountManagement from './account-management'
import storeAccountManagement from './store-account-management'
import developInfo from './develop-info'
import securitiesTemplate from './securities-template'
import securitiesBatch from './securities-batch'
import newcoupon from './newcoupon' // securitiesBatch里的组件
import securitiesManagement from './securities-management'
import tdSignup from './td-signup'
import tdSignupMine from './td-signup-mine'
import dialogmessage from './dialog-message'
import dialogueinterface from './dialogueinterface' // dialogmessage里的聊天页面
import coinsPlan from './coins-plan'
import recommendProduct from './recommend-product'
import activitySignup from './activity-signup'
import aftersales from './aftersales'
import detailShow from './detail-show' // aftersales里的组件
import liquidation from './liquidation'
import activityintegrate from './activityintegrate'
import bigpromotionmine from './bigpromotionmine'
import activityflash from './activityflash'
import activitymodal from './activitymodal' // activityflash里的组件
// import activitypromotion from './activitypromotion'
import fullfunctionediting from './fullfunctionediting'
import acproductsignup from './acproductsignup'
import activitybigpromotion from './activitybigpromotion'
import promotionallist from './promotionallist'
import postagestrategy from './postagestrategy'
import sellerCenter from './seller-center'
import expressAccount from './express-account'
import applyUseWarehouse from './applyUseWarehouse.js'
import stockUp from './stock-up.js'
import message from './message.js'
import fundAcc from './fund-account'
import insights from './insights'
import storePostageStrategy from './store-postage-strategy'
import draftGoods from './draft-goods.js'
import orderList from './order/list.js'
import orderDetail from './order/detail.js'
import clearing from './clearing/index.js'
import limitedTimeDeal from './limited-time-deal.js'
import cms from './cms.js'
import expressReturn from './express/return'
import billFee from './bill/fee'
import groupsignupmine from './groupsignupmine'
import shopNews from './shop-news'
import afterSaleNew from './after-sale-new'
import address from './address'
import expenseAppeal from './expense-appeal.js'
import closeStore from './close-store'
import complaint from './complaint'
import gallery from './gallery'

export default {
  home,
  fundAcc,
  addProduct,
  saleOrder,
  components,
  productList,
  productListGift,
  productSku,
  catset,
  goodsImport,
  productReviews,
  reviewList,
  extendedPrice,
  _idorder,
  shippackage,
  shippackagedetail,
  _id,
  storelist,
  storeSetting,
  accountManagement,
  storeAccountManagement,
  developInfo,
  securitiesTemplate,
  securitiesBatch,
  newcoupon,
  securitiesManagement,
  tdSignup,
  tdSignupMine,
  dialogmessage,
  dialogueinterface,
  coinsPlan,
  recommendProduct,
  activitySignup,
  aftersales,
  detailShow,
  liquidation,
  activityintegrate,
  bigpromotionmine,
  activityflash,
  activitymodal,
  fullfunctionediting,
  ecourier,
  acproductsignup,
  activitybigpromotion,
  promotionallist,
  postagestrategy,
  sellerCenter,
  expressAccount,
  applyUseWarehouse,
  stockUp,
  message,
  insights,
  storePostageStrategy,
  draftGoods,
  orderList,
  orderDetail,
  clearing,
  limitedTimeDeal,
  cms,
  expressReturn,
  billFee,
  groupsignupmine,
  shopNews,
  afterSaleNew,
  address,
  expenseAppeal,
  closeStore,
  complaint,
  gallery
}
